/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplyClaimBalanceSurchargeRequest,
  CarryForwardClaimBalancesRequest,
  ClaimBalanceCarryForwardResponse,
  ClaimBalanceSurchargeResponse,
  ClaimResponse,
  CreateClaimRequest,
  ProblemDetails,
  UpdateClaimRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    ApplyClaimBalanceSurchargeRequestFromJSON,
    ApplyClaimBalanceSurchargeRequestToJSON,
    CarryForwardClaimBalancesRequestFromJSON,
    CarryForwardClaimBalancesRequestToJSON,
    ClaimBalanceCarryForwardResponseFromJSON,
    ClaimBalanceCarryForwardResponseToJSON,
    ClaimBalanceSurchargeResponseFromJSON,
    ClaimBalanceSurchargeResponseToJSON,
    ClaimResponseFromJSON,
    ClaimResponseToJSON,
    CreateClaimRequestFromJSON,
    CreateClaimRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateClaimRequestFromJSON,
    UpdateClaimRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface ApplyClaimBalanceSurchargeOperationRequest {
    clientId: string;
    applyClaimBalanceSurchargeRequest: ApplyClaimBalanceSurchargeRequest;
}

export interface CarryForwardClaimBalancesOperationRequest {
    clientId: string;
    carryForwardClaimBalancesRequest: CarryForwardClaimBalancesRequest;
}

export interface CreateClaimOperationRequest {
    clientId: string;
    createClaimRequest: CreateClaimRequest;
}

export interface DeleteClaimRequest {
    clientId: string;
    claimId: string;
}

export interface GetClaimByIdRequest {
    clientId: string;
    claimId: string;
}

export interface GetClaimsByClientIdRequest {
    clientId: string;
}

export interface UpdateClaimOperationRequest {
    clientId: string;
    claimId: string;
    updateClaimRequest: UpdateClaimRequest;
}

/**
 * ClaimsApi - interface
 * 
 * @export
 * @interface ClaimsApiInterface
 */
export interface ClaimsApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {ApplyClaimBalanceSurchargeRequest} applyClaimBalanceSurchargeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    applyClaimBalanceSurchargeRaw(requestParameters: ApplyClaimBalanceSurchargeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimBalanceSurchargeResponse>>;

    /**
     */
    applyClaimBalanceSurcharge(requestParameters: ApplyClaimBalanceSurchargeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimBalanceSurchargeResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {CarryForwardClaimBalancesRequest} carryForwardClaimBalancesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    carryForwardClaimBalancesRaw(requestParameters: CarryForwardClaimBalancesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimBalanceCarryForwardResponse>>;

    /**
     */
    carryForwardClaimBalances(requestParameters: CarryForwardClaimBalancesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimBalanceCarryForwardResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {CreateClaimRequest} createClaimRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    createClaimRaw(requestParameters: CreateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimResponse>>;

    /**
     */
    createClaim(requestParameters: CreateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    deleteClaimRaw(requestParameters: DeleteClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteClaim(requestParameters: DeleteClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimByIdRaw(requestParameters: GetClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimResponse>>;

    /**
     */
    getClaimById(requestParameters: GetClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimsByClientIdRaw(requestParameters: GetClaimsByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClaimResponse>>>;

    /**
     */
    getClaimsByClientId(requestParameters: GetClaimsByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClaimResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} claimId 
     * @param {UpdateClaimRequest} updateClaimRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    updateClaimRaw(requestParameters: UpdateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimResponse>>;

    /**
     */
    updateClaim(requestParameters: UpdateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimResponse>;

}

/**
 * 
 */
export class ClaimsApi extends runtime.BaseAPI implements ClaimsApiInterface {

    /**
     */
    async applyClaimBalanceSurchargeRaw(requestParameters: ApplyClaimBalanceSurchargeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimBalanceSurchargeResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling applyClaimBalanceSurcharge().'
            );
        }

        if (requestParameters['applyClaimBalanceSurchargeRequest'] == null) {
            throw new runtime.RequiredError(
                'applyClaimBalanceSurchargeRequest',
                'Required parameter "applyClaimBalanceSurchargeRequest" was null or undefined when calling applyClaimBalanceSurcharge().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/claims/balance-surcharge`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplyClaimBalanceSurchargeRequestToJSON(requestParameters['applyClaimBalanceSurchargeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimBalanceSurchargeResponseFromJSON(jsonValue));
    }

    /**
     */
    async applyClaimBalanceSurcharge(requestParameters: ApplyClaimBalanceSurchargeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimBalanceSurchargeResponse> {
        const response = await this.applyClaimBalanceSurchargeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async carryForwardClaimBalancesRaw(requestParameters: CarryForwardClaimBalancesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimBalanceCarryForwardResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling carryForwardClaimBalances().'
            );
        }

        if (requestParameters['carryForwardClaimBalancesRequest'] == null) {
            throw new runtime.RequiredError(
                'carryForwardClaimBalancesRequest',
                'Required parameter "carryForwardClaimBalancesRequest" was null or undefined when calling carryForwardClaimBalances().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/claims/balance-carry-forward`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CarryForwardClaimBalancesRequestToJSON(requestParameters['carryForwardClaimBalancesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimBalanceCarryForwardResponseFromJSON(jsonValue));
    }

    /**
     */
    async carryForwardClaimBalances(requestParameters: CarryForwardClaimBalancesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimBalanceCarryForwardResponse> {
        const response = await this.carryForwardClaimBalancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createClaimRaw(requestParameters: CreateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling createClaim().'
            );
        }

        if (requestParameters['createClaimRequest'] == null) {
            throw new runtime.RequiredError(
                'createClaimRequest',
                'Required parameter "createClaimRequest" was null or undefined when calling createClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/claims`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimRequestToJSON(requestParameters['createClaimRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimResponseFromJSON(jsonValue));
    }

    /**
     */
    async createClaim(requestParameters: CreateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimResponse> {
        const response = await this.createClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteClaimRaw(requestParameters: DeleteClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deleteClaim().'
            );
        }

        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling deleteClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/claims/{claimId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteClaim(requestParameters: DeleteClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getClaimByIdRaw(requestParameters: GetClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClaimById().'
            );
        }

        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/claims/{claimId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimResponseFromJSON(jsonValue));
    }

    /**
     */
    async getClaimById(requestParameters: GetClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimResponse> {
        const response = await this.getClaimByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClaimsByClientIdRaw(requestParameters: GetClaimsByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClaimResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClaimsByClientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/claims`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimResponseFromJSON));
    }

    /**
     */
    async getClaimsByClientId(requestParameters: GetClaimsByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClaimResponse>> {
        const response = await this.getClaimsByClientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateClaimRaw(requestParameters: UpdateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateClaim().'
            );
        }

        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling updateClaim().'
            );
        }

        if (requestParameters['updateClaimRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClaimRequest',
                'Required parameter "updateClaimRequest" was null or undefined when calling updateClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/claims/{claimId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClaimRequestToJSON(requestParameters['updateClaimRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateClaim(requestParameters: UpdateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimResponse> {
        const response = await this.updateClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
